export default __webpack_public_path__ + "media/images/mailer-new/common/logo-header-c12ac8ebdee2a953563096b681dab760.png";